import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { IconButton, InputBase, InputBaseProps } from '@mui/material'
export const ButtonQuantityV2 = ({
  quantity,
  setQuantity,
  props,
}: {
  quantity: number
  setQuantity: (quantity: number) => void
  props?: Omit<InputBaseProps, 'children'>
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value

    // Remove all non-digit characters (including dots/commas from locale formatting)
    const digitsOnly = value.replace(/\D/g, '')

    if (digitsOnly === '') {
      setQuantity(0)
    } else {
      setQuantity(parseInt(digitsOnly, 10))
    }
  }

  const handleIncrement = () => {
    setQuantity(quantity + 1)
  }

  const handleDecrement = () => {
    if (quantity <= 1) return
    setQuantity(quantity - 1)
  }

  const handleBlur = () => {
    // Đảm bảo số lượng tối thiểu là 1
    if (quantity < 1) {
      setQuantity(1)
    }
  }

  return (
    <InputBase
      {...props}
      value={quantity.toLocaleString('vi-VN')}
      onChange={handleInputChange}
      onBlur={handleBlur}
      type="text"
      inputProps={{
        inputMode: 'numeric',
        pattern: '[0-9]*',
        style: {
          width: `${Math.max(quantity.toString().length * 10 + 8, 28)}px`,
          minWidth: '28px',
          height: '24px',
          ...props?.inputProps?.style,
        },
      }}
      sx={{
        '& .MuiInputBase-input': {
          textAlign: 'center',
          color: 'inherit',
          padding: {
            xs: '0px 4px',
            md: '0px 8px',
          },
          fontSize: { xs: '1rem', md: '1.25rem' },
        },
        border: '1px solid',
        borderColor: 'bd.main',
        borderRadius: '999px',
        color: 'primary.main',
        display: 'inline-flex',
        width: 'fit-content',
        padding: {
          xs: '2px',
          md: '4px',
        },
        ...props?.sx,
      }}
      endAdornment={
        <IconButton color="inherit" onClick={handleIncrement} size="small">
          <AddIcon sx={{ fontSize: '20px', color: 'inherit' }} />
        </IconButton>
      }
      startAdornment={
        <IconButton color="inherit" onClick={handleDecrement} size="small">
          <RemoveIcon sx={{ fontSize: '20px', color: 'inherit' }} />
        </IconButton>
      }
    />
  )
}
